module.exports = __webpack_public_path__ + "media/country_flags/jp-825bb098.png";